import { useLayoutEffect, useState, type RefObject } from 'react';

/** En dessous de cette largeur (px), une colonne du calendrier ne peut plus porter une carte lisible. */
export const LARGEUR_MIN_COLONNE_CARTE = 150;

/**
 * Les colonnes du calendrier sont-elles trop étroites pour des cartes (téléphone, zoom à 200 %, menu ouvert sur petit écran) ?
 * Mesuré sur la largeur réelle de l'élément (jamais sur celle de la fenêtre : le menu de gauche et le zoom la changent) ;
 * le calendrier retombe alors sur les points et le détail du jour, sans rien perdre.
 */
export function useColonneEtroite(ref: RefObject<HTMLElement | null>, seuil: number = LARGEUR_MIN_COLONNE_CARTE): boolean {
  const [etroit, setEtroit] = useState(false);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const mesurer = () => setEtroit(el.getBoundingClientRect().width / 5 < seuil);
    mesurer();
    if (typeof ResizeObserver === 'undefined') return;
    const observateur = new ResizeObserver(mesurer);
    observateur.observe(el);
    return () => observateur.disconnect();
  }, [ref, seuil]);
  return etroit;
}
